import {Component} from '@angular/core';
import {NotificationsService} from 'angular2-notifications';
import {TranslateService} from '@ngx-translate/core';
// tslint:disable-next-line:max-line-length
import {FinancialOperationRefundService} from '../../../financial-operation/financial-operation-list/financial-operation-view/financial-operation-refund.service';

@Component({
  selector: 'app-subscription-purchase-log-action-render',
  templateUrl: './subscription-purchase-log-action-render.component.html',
})
export class SubscriptionPurchaseLogActionRenderComponent {
  public params: any;

  constructor(
    public notif: NotificationsService,
    public translate: TranslateService,
    protected financialOperationRefundService: FinancialOperationRefundService
  ) { }

  agInit(params: any): void {
    this.params = params;
  }

  cancelClick() {
    if (this.params.data
      && this.params.data.id
      && window.confirm(this.translate.instant('Are you sure you want to cancel your subscription purchase and get a refund?'))
    ) {
      this.financialOperationRefundService.refund(this.params.data.financial_operation_id)
        .subscribe(
          result => {
            if (result) {
              this.notif.success(this.translate.instant('Transaction was successfully refunded'));
            } else {
              this.notif.error(this.translate.instant('Error of transaction refund'));
            }
            this.params.context.refreshGrid();
          }
        );
    }
  }
}
